import { signal } from "@angular/core";
import { StoreModelCollection } from "@bitwarden/web-vault/app/services/store/model.collection.abstraction";
import { StoreModelNames } from "../../dali/type/dali.type";
import { SavingGoalStoreModel } from "../../../models/store/saving-goal.store.model";
import { SavingGoalView } from "@bitwarden/web-vault/app/models/view/saving-goal/saving-goal.view";

export class SavingGoalStoreCollection extends StoreModelCollection {
  readonly type: StoreModelNames = "SavingGoalStoreModel";

  protected models: Map<string, SavingGoalStoreModel> = new Map<string, SavingGoalStoreModel>();

  private _savingGoalViews = signal<SavingGoalView[]>(null);
  readonly savingGoalViews = this._savingGoalViews.asReadonly();

  triggerChanges(): void {
    this._savingGoalViews.set(this.buildViews(this.models, (model) => new SavingGoalView(model)));
  }

  clear(): void {
    this.models.clear();
    this._savingGoalViews.set(null);
  }
}
